import fetchData from './fetchData';

export default function getSearchUrl(){
    return dispatch => {


        /**
		 * Check URL params.
		 * Als je benamingen aanpast -> ook in fetchData() functie aanpassen.
		 */

		var url   = window.location.search;
		var query = new URLSearchParams( url );

		let page = query.get( 'page' ) ? query.get( 'page' ) : '';
		let string = query.get( 'q' ) ? query.get( 'q' ) : '';

		let categories  = query.get( 'categories' ) ? query.get( 'categories' ) : '';
		let tech  = query.get( 'tech' ) ? query.get( 'tech' ) : '';

		let order  = query.get( 'order' ) ? query.get( 'order' ) : '';

		dispatch( fetchData( page, string, categories, tech, order ) );
    }
}